module.exports = __webpack_public_path__ + "static/media/circle_blue.f618d662.svg";